import { CLEAR_SITE_DATA } from '../application/actions';
import {
  RECEIVE_INTEGRATIONS,
  RECEIVE_INTEGRATION_TEMPLATES,
  RECEIVE_INTEGRATION,
  REMOVE_INTEGRATION,
} from './actions';

const initialState = {
  integrationTypes: [],
  integrations: [],
  templates: [],
  loadedScope: undefined, // either site id or org
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_INTEGRATIONS: {
      return {
        ...state,
        integrationTypes: action.integrationTypes,
        integrations: action.integrations,
        loadedScope: action.loadedScope,
      };
    }
    case RECEIVE_INTEGRATION_TEMPLATES: {
      return {
        ...state,
        templates: action.templates,
      };
    }
    case RECEIVE_INTEGRATION: {
      const { integration } = action;
      const integrationIndex = state.integrations.findIndex((index) => index.id === integration.id);
      if (integrationIndex === -1) {
        return { ...state, integrations: [...state.integrations, integration] };
      }
      return {
        ...state,
        integrations: [
          ...state.integrations.slice(0, integrationIndex),
          integration,
          ...state.integrations.slice(integrationIndex + 1),
        ],
      };
    }
    case REMOVE_INTEGRATION: {
      const { id } = action;
      const integrationIndex = state.integrations.findIndex((index) => index.id === id);
      if (integrationIndex !== -1) {
        return {
          ...state,
          integrations: [
            ...state.integrations.slice(0, integrationIndex),
            ...state.integrations.slice(integrationIndex + 1),
          ],
        };
      }
      return state;
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
